(function () {
    'use strict';

    angular
        .module('wizard-english-test.services')
        .service('PersonEventService', PersonEventService);

    /** @ngInject */
    function PersonEventService(HttpService) {
        return {
            getEventById,
            getEventByCode
        };

        // GET /person-events/{id}
        function getEventById(id) {
            return HttpService.get('/person-events/' + id);
        }

        // GET /person-events/code/{cpf}
        function getEventByCode(cpf) {
            return HttpService.get('/person-events/code/' + cpf);
        }
    }
}());
